export const alertNotificationHeaderData = [
    {
        field: 'RowId',
        headerName: 'Row ID',
        width: '80',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'BpRegion',
        headerName: 'BP Region (SAP PM)',
        width: '130',
        hideInTable: false,
        isDisabled: false,
        sortable: true
    },
    {
        field: 'BpRegionAlias',
        headerName: 'BP Region Alias',
        width: '130',
        hideInTable: false,
        isDisabled: false,
        sortable: true
    },
    {
        field: 'Title',
        headerName: 'Title',
        width: '200',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'AlertMessage',
        headerName: 'Alert Message',
        width: '420',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'BackgroundColor',
        headerName: 'Background Color',
        width: '130',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'TextColor',
        headerName: 'Text Color',
        width: '130',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'AlertStartDate',
        headerName: 'Alert Start Date',
        width: '130',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'AlertEndDate',
        headerName: 'Alert End Date',
        width: '130',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'Status',
        headerName: 'Status',
        width: '130',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedBy',
        headerName: 'Created By',
        width: '110',
        hideInTable: false,
        isDisabled: false,
    },
    {
        field: 'CreatedDate',
        headerName: 'Created Date',
        width: '140',
        hideInTable: false,
        isDisabled: false,
        type: 'date'
    },
    {
        field: 'LastModifiedBy',
        headerName: 'Last Modified By',
        width: '110',
        hideInTable: false,
        isDisabled: false
    },
    {
        field: 'LastModifiedDate',
        headerName: 'Last Modified Date',
        width: '140',
        hideInTable: false,
        isDisabled: false,
        type: 'date'
    },
    {
        field: 'Comment',
        headerName: 'Comment',
        width: '350',
        hideInTable: false,
        isDisabled: false,
    },
];

export const alertNotificationInitialState = {
    RowId: '',
    Region: '',
    BpRegionAlias: '',
    Title: '',
    AlertMessage: '',
    BackgroundColor: 'White',
    TextColor: 'Black',
    AlertStartDate: '',
    AlertEndDate: '',
    Status: 'Inactive',
    CreatedBy: '',
    CreatedDate: '',
    LastModifiedBy: '',
    LastModifiedDate: '',
    Comment: ''
};

export const alertNotificationSearchState = {
    RowId: '',
    Region: '',
    BpRegionAlias: '',
    Title: '',
    AlertMessage: '',
    BackgroundColor: '',
    TextColor: '',
    AlertStartDate: '',
    AlertEndDate: '',
    Status: '',
    CreatedBy: '',
    CreatedDate: '',
    LastModifiedBy: '',
    LastModifiedDate: '',
    Comment: ''
};

export const alertNotificationApiEndpoint = {
    read: 'ADMIN_GetAlertNotification'
};
